module.exports = __webpack_public_path__ + "img/portrait1thumb.146ef7d0.jpg";